export default { 
  Dashboard: require('./Dashboard').default,
}